import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section } from './Shared';
export type TestimonialProps = {
  initials: string;
  name: string;
  location: string;
  product?: string;
  text: string;
  accent?: 'green' | 'rose' | 'lavender';
};
const accents: Record<NonNullable<TestimonialProps['accent']>, string> = {
  green: 'bg-brand-green',
  rose: 'bg-brand-rose',
  lavender: 'bg-brand-lavender'
};
export function TestimonialCard({
  initials,
  name,
  location,
  product,
  text,
  accent = 'green'
}: TestimonialProps) {
  return <article className="paper-panel flex h-full flex-col rounded-2xl border-l-4 border-l-brand-greenMid p-6 md:p-8" data-id="element-276" data-mp="31yl4z0tjvmmr">
      <div className="mb-4 flex items-center" data-id="element-277" data-mp="2x2mnzyajx6wd">
        <div className={`mr-4 flex h-12 w-12 shrink-0 items-center justify-center rounded-full text-sm font-bold text-brand-cream ring-1 ring-brand-gold/40 md:text-lg ${accents[accent]}`} data-id="element-278" data-mp="2s2rwptmv6fas">
          {initials}
        </div>
        <div data-id="element-279" data-mp="qav93lnf9ezn">
          <div className="mb-1 flex text-brand-amber" data-id="element-280" data-mp="q893vso07bkl">
            {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-4 w-4 fill-current" data-id="element-281" data-mp="m51dby0rthb2" />)}
          </div>
          <p className="font-semibold text-brand-text md:text-lg" data-id="element-282" data-mp="m2ygov544pxd">{name}</p>
          <p className="text-xs text-brand-muted md:text-sm" data-id="element-283" data-mp="79bpduc0yu3p">
            {location}
            {product ? ` — ${product}` : ''}
          </p>
        </div>
      </div>
      <p className="flex-grow font-serif text-sm italic leading-relaxed text-brand-textLight md:text-base" data-id="element-284" data-mp="zw674jhgjfdh">“{text}”</p>
    </article>;
}
const testimonials: TestimonialProps[] = [{
  initials: 'MV',
  name: 'María V.',
  location: 'Ciudad de México, México',
  product: 'Terapeuta holística',
  accent: 'green',
  text: 'Por primera vez tengo un sistema completo para mis sesiones. Mis pacientes perciben la diferencia desde el primer momento y cuando les explico qué flores usé y por qué, sienten que están en manos de una profesional real.'
}, {
  initials: 'CL',
  name: 'Carolina L.',
  location: 'Bogotá, Colombia',
  product: 'Terapeuta energética',
  accent: 'rose',
  text: 'El Escudo del Terapeuta solo ya vale todo el pack. Antes llegaba a casa agotada sin entender por qué. Ahora, con las técnicas de blindaje, la diferencia es enorme.'
}, {
  initials: 'SM',
  name: 'Sofía M.',
  location: 'Lima, Perú',
  product: 'Terapeuta en formación',
  accent: 'lavender',
  text: 'Recién empezaba y el Botiquín Bach me dio la estructura que necesitaba desde la primera sesión. Llegué al consultorio con criterio desde el día uno.'
}];
export function InitialTestimonials() {
  return <Section className="pb-14 pt-6" data-id="element-285" data-mp="14t22g5dwcfpn">
      <div className="mx-auto max-w-3xl" data-id="element-286" data-mp="14u4uwhqvaq7o">
        <TestimonialCard {...testimonials[0]} data-id="element-287" data-mp="10rqb9vfdjmfc" />
      </div>
    </Section>;
}
export function MoreTestimonials() {
  return <Section className="pb-16 pt-8" data-id="element-288" data-mp="vsdmh54y05a4">
      <div className="mb-10 text-center" data-id="element-289" data-mp="vrc40fllkgid">
        <h2 className="font-display text-2xl font-bold text-brand-green md:text-4xl" data-id="element-290" data-mp="qtkaxi97uocl">
          ❤️ LO QUE DICEN LOS TERAPEUTAS QUE YA LO TIENEN
        </h2>
      </div>
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-6 md:grid-cols-3" data-id="element-291" data-mp="32gnt6sxrnh3v">
        {testimonials.map(testimonial => <TestimonialCard key={testimonial.initials} {...testimonial} data-id="element-292" data-mp="37i3d2ho7jhko" />)}
      </div>
    </Section>;
}